import { InjectableService } from "@/shared/services/InjectableService";
import { QueueCustomCalculationsArgs } from "@/shared/Executions/models/QueueCustomCalculationsArgs";
import { AxiosResponse } from "axios";
import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";


export interface ICalculationsApiService {
    processCalculations: (userId: string, tenantId: string, args: QueueCustomCalculationsArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
}


export class CalculationsApiService extends InjectableService implements ICalculationsApiService {

    static readonly injectableKey = 'ICalculationsApiService';

    get injectableKey() {
        return (this.constructor as typeof CalculationsApiService).injectableKey;
    }

    constructor(private readonly _executionApiService: IExecutionApiService) {
        super()
    }

    public async processCalculations(userId: string, tenantId: string, args: QueueCustomCalculationsArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

        const qeueueExecutionArgs = new QueueExecutionArgs({ tenantId, userId, customCalculationsArgs: args });

        return await this._executionApiService.queueExecution(qeueueExecutionArgs);
    }

}
